import React from "react";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ColDynamic from "../WrapperComponents/ColDynamic";
import TextField from "@material-ui/core/TextField";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import Select from "react-virtualized-select";
import { PlusCircleOutlined, MinusCircleOutlined } from "@ant-design/icons";

const OfficeAddress = (props) => {
  const officeAddress = props.parentState.newFormData.officeAddress.find(
    (element) => element.id === props.id
  );

  const addressArrayLength =
    props.parentState.newFormData.officeAddress.length > 1;

  const { countryList } = props.parentState;

  return (
    <div className="form-group">
      <Row>
        <ColDynamic className="col-lg-4 mb-16">
          <>
            <label>Država</label>
            <Select
              noResultsText={"Nema rezultata"}
              placeholder="Odaberi državu"
              options={countryList}
              onChange={(selectValue) =>
                props.setCountryAutocompleteHandler(selectValue, {
                  formGroup: props.objData.group,
                  value: "country",
                  code: "sifDrzave",
                  id: props.id || null,
                })
              }
              labelKey="nazivKratki"
              valueKey="sifDrzave"
              value={officeAddress.sifDrzave}
              //style={{ marginTop: "32px" }}
            />
          </>
        </ColDynamic>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              officeAddress.nazNaselja.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "officeAddress" }}
            value={officeAddress.nazNaselja}
            id={`naziv-naselja-adr-ureda${props.id}`}
            name="nazNaselja"
            controlLabel={"Naziv mjesta"}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              officeAddress.brPoste.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "officeAddress" }}
            value={officeAddress.brPoste}
            id={`br-poste-adr-ureda${props.id}`}
            name="brPoste"
            controlLabel={"Poštanski broj"}
          />
        </Col>
        <Col>
          <InputComponent
            required={props.required}
            style={
              props.required &&
              props.parentState.error &&
              officeAddress.ulicaKbr.length < 1 &&
              "red"
            }
            onChange={props.mappedUserInputHandler}
            objData={{ id: props.id, group: "officeAddress" }}
            value={officeAddress.ulicaKbr}
            id={`ulica-kbr-adr-ureda${props.id}`}
            name="ulicaKbr"
            controlLabel={"Ulica i kućni broj"}
          />
        </Col>
      </Row>

      <Row>
        <ColDynamic className="col-lg-4">
          {props.idZaBtn === props.parentState.newFormData.officeAddress.length - 1 ? 
            <ButtonComponent
              id={`multiply-component-btn-adr-ureda${props.id}`}
              onClick={(e) =>
                props.multiplyComponent(e, { formGroup: "officeAddress" })
              }
            >
              Dodaj novi
              {/* <PlusCircleOutlined /> */}
            </ButtonComponent>
            : null
        }
        </ColDynamic>
        <ColDynamic className="col-lg-4">
          {addressArrayLength && (
            <ButtonComponent
              variant="danger"
              id={`remove-component-btn-adr-ureda${props.id}`}
              onClick={(e) =>
                props.removeComponentHandler(e, { formGroup: "officeAddress" })
              }
            >
              Ukloni
              {/* <MinusCircleOutlined /> */}
            </ButtonComponent>
          )}
        </ColDynamic>
      </Row>
    </div>
  );
};

export default OfficeAddress;
